module Meevo.Components.Controls.SmartMover {

    import Dictionary = _.Dictionary;

    export class DiscountFeesDataTemplate extends DataTemplateBase implements IDataTemplate {

        protected discountFees: DiscountFeesCollection;

        public title: string;
        public allSelectedLabel: string;
        public totalSelectedMessage: string;

        get collection() {
            return this.discountFees;
        }

        get leafCollection() {
            return this.discountFees;
        }

        reconnectLeafCollectionModel(model)
        {
            this.leafCollection.connectedModel = model[this.properties[0]];
        }

        constructor(model: Dictionary<any>, properties: string[], { criteria }) {
            super(model, properties, criteria);

            this.discountFees = new DiscountFeesCollection(this.model[properties[0]], [], {
                criteria,
                smartMoverHidden: () => this.smartMoverHidden
            });

            this.showAllSelected = false;
            this.allSelectedLabel = 'LABEL_ALL_DISCOUNT_FEES';
            this.totalSelectedMessage = 'LABEL_TOTAL_DISCOUNT_FEES_SELECTED';
        }
    }
}